import processReport from '@/assets/js/report/order_packing'
export default {
  methods: {
    async genereatePackReportContent (getObj) {
      // let getObj = this.listPayloadObj.list ? this.listPayloadObj.list.find(x => x.id === id) : {}
      if (!getObj) getObj = {}
      const customerLang = (getObj && getObj.customer_language) ? getObj.customer_language : this.$i18n.locale
      const lang = this.$i18n.messages[customerLang].message
      if (getObj) {
        const headers = [{ text: lang.orders.productNo, value: 'number', width: '16%' },
          { text: lang.customer.name, value: 'producttext', width: '25%' },
          { text: lang.product.qty, value: 'qty', width: '10%' },
          { text: lang.products.unit, value: 'productunit_name', width: '10%' },
          { text: lang.order.deliveryDate, value: 'updatedon', width: '11%' },
          { text: lang.order.deliveredQty, value: 'deliveredqty', width: '10%' },
          { text: lang.common.pickedqty, value: 'pickedqty', width: '13%' },
          { text: lang.order.rest, value: 'rest', width: '13%' }
        ]
        const products = await this.getOrderPackProducts(getObj.id, getObj.type, getObj.restcreatedfrom)
        const translationData = {
          confirm: lang.orders.packList,
          number: lang.order.orderNumber,
          customer: lang.order.customer,
          contact: lang.orders.contact,
          deliveryaddress: lang.orders.deliveryAddress,
          responsible: lang.deviations.responsible,
          ourreference: lang.orders.ourReference,
          yourreference: lang.orders.yourReference,
          offerdate: lang.orders.offerDate,
          orderdate: lang.whOrder.orderDate,
          deliverydate: lang.order.shippingDate,
          shipment: lang.customer.shipmentReport,
          paymentTerm: lang.order.paymentTerms,
          deliveryTerm: lang.order.deliveryTerm,
          invoiceTo: lang.orders.invoiceTo,
          invoiceAddress: lang.orders.invoiceAddress,
          days: lang.common.days,
          restorder: lang.orders.restOrderFor
        }
        const getBase64Content = processReport(headers, products, getObj, translationData, getObj.restcreatedfromnumber, 3)
        return getBase64Content
      }
    },
    getOrderPackProducts (id, type, restOrder) {
      return new Promise((resolve, reject) => {
        this.$_executeApi('get', `orders/get_materials_packlist/${id}`)
          .then((response) => {
            if (response.data) {
              const allMaterials = response.data
              var pickedQtyCalculatedList = allMaterials
              const getMaterialsForRest = pickedQtyCalculatedList.filter(x => !x.packageid && (x.orderindex === null || x.orderindex <= 0))
              getMaterialsForRest.map(x => {
                // check for splitted rows
                let getPicked = x.pickedqty
                var getChildren = pickedQtyCalculatedList.filter(z => z.orderindex === x.id)
                if (getChildren && getChildren.length > 0) {
                  getChildren.map(y => {
                    getPicked += y.pickedqty
                  })
                }
                const pickedQty = getPicked
                x.rest = pickedQty ? (x.qty - pickedQty) : x.qty
                if (x.isrestfirstrow) {
                  x.rest = pickedQty ? (x.realqty - pickedQty) : 0
                }
                x.qty = this.$formatter.replaceDotWithComma(x.qty)
                x.pickedqty = this.$formatter.replaceDotWithComma(Math.abs(pickedQty - x.deliveredqty))
                x.rest = this.$formatter.replaceDotWithComma(x.rest)
                x.deliveredqty = this.$formatter.replaceDotWithComma(x.deliveredqty)
                if (x.isfreight || x.product_type === 'work') { // x.ispackage ||
                  x.rest = '0,00'
                }
                x.updatedon = this.$formatter.formatDate(x.updatedon, 'DD.MM.YYYY', 'DD.MM.YYYY')
                if (x.isfreight) {
                  x.producttext = 'Frakt'
                  x.number = '1000'
                }
                return x
              })
              resolve(getMaterialsForRest)
            }
          })
          .catch((err) => {
            reject(err)
          })
      })
    }
  }
}
